/* Place Vassia's photo/review product card after the article content and
   before the related-reading links across both Shopify article templates.
   Preserve inline article links, narrative text, and original FAQ sections. */
(() => {
  const readingHeading = /related[\s-]*(guides|articles|posts|reading|resources)|more[\s-]*(hair[\s-]*)?(guides|articles|reading)|further[\s-]*reading|sources[\s-]*and[\s-]*further[\s-]*reading|references[\s-]*and[\s-]*further[\s-]*reading|(?:more|recommended|explore)[\s\S]{0,45}(guides|articles)|continue[\s-]*reading|read[\s-]*next|you[\s-]*might[\s-]*also[\s-]*like/i;
  const readingIntro = /^(?:related|further reading|more from vassia|also read|read next)\s*:?$/i;
  const blogLinks = node => node && node.querySelectorAll('a[href*="/blogs/"]').length;
  const isWithinCTA = node => !!node.closest('.vassia-reader__cta');
  const insideContents = node => !!node.closest('.vassia-reader__contents, nav, .vassia-revive-ribbon');
  const isHeading = node => /^H[1-6]$/.test(node.tagName);

  function installProductCards() {
    document.querySelectorAll('.article-template__content').forEach(article => {
      const cta = article.querySelector('.vassia-reader__cta');
      const template = article.querySelector('template[data-vassia-blog-product-photo]');
      if (!cta || !template) return;

      if (cta.dataset.vassiaProductCardReady !== 'true') {
        const photo = template.content.firstElementChild;
        if (photo && !cta.querySelector('.vassia-reader__product-photo')) {
          cta.insertAdjacentElement('afterbegin', photo.cloneNode(true));
        }
        cta.classList.add('vassia-reader__cta--product-card');
        cta.dataset.vassiaProductCardReady = 'true';
      }

      const root = article.querySelector('.vassia-reader') || article;
      const related = new Set();
      const keep = el => {
        if (!el || !el.isConnected || el === cta || el.contains(cta) ||
            cta.contains(el) || isWithinCTA(el) || insideContents(el)) return;
        related.add(el);
      };

      /* Related and reading blocks may appear before FAQs in older posts.
         Relocate only these link blocks, not the article's main content. */
      for (const heading of root.querySelectorAll('h2, h3, h4')) {
        if (isWithinCTA(heading) || insideContents(heading)) continue;
        const label = ((heading.id || '') + ' ' + heading.textContent).trim();
        if (!readingHeading.test(label)) continue;

        const section = heading.closest('section');
        if (section && section !== root && !section.contains(cta) &&
            section.querySelectorAll('h2, h3').length === 1 && blogLinks(section)) {
          keep(section);
          continue;
        }

        const group = [heading];
        let next = heading.nextElementSibling;
        for (let i = 0; i < 7 && next; i++) {
          if (isHeading(next) || next.matches('.vassia-reader__cta, .vassia-revive-ribbon')) break;
          if (next.matches('ul, ol, p, div') && blogLinks(next)) {
            group.push(next);
            next = next.nextElementSibling;
            continue;
          }
          break;
        }
        if (group.length > 1) group.forEach(keep);
      }

      /* Supplementary link blocks without a conventional heading. */
      for (const aside of root.querySelectorAll('aside')) {
        if (aside === cta || aside.contains(cta) || insideContents(aside) || !blogLinks(aside)) continue;
        const label = (aside.getAttribute('aria-label') || '') + ' ' +
          (aside.querySelector('h2,h3,h4')?.textContent || '');
        if (readingHeading.test(label)) keep(aside);
      }
      for (const p of root.querySelectorAll('p')) {
        if (isWithinCTA(p) || insideContents(p) || p.closest('aside, li')) continue;
        const first = (p.querySelector('strong')?.textContent || '').trim();
        if (readingIntro.test(first) && blogLinks(p)) keep(p);
      }

      /* Catch standalone, link-only reading lists near the end of a post. */
      const blocks = Array.from(root.children);
      for (let i = Math.floor(blocks.length * .7); i < blocks.length; i++) {
        const block = blocks[i];
        if (!block || block === cta || block.contains(cta) || insideContents(block)) continue;
        if (block.matches('ul, ol') && blogLinks(block) >= 2 &&
            block.querySelectorAll('a[href]').length === blogLinks(block)) keep(block);
      }

      /* Keep the original order of internal-link sections after the card. */
      const items = Array.from(related).filter(el =>
        !Array.from(related).some(other => other !== el && other.contains(el))
      );
      items.sort((a, b) =>
        (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1
      );
      if (items.length) {
        const fragment = document.createDocumentFragment();
        for (const item of items) {
          if (item.isConnected && !item.contains(cta)) fragment.appendChild(item);
        }
        cta.after(fragment);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installProductCards, { once: true });
  } else installProductCards();
  document.addEventListener('shopify:section:load', installProductCards);
})();
